<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <div>
          <div class="content">
            <p>
              Sorry, your browser (Internet Explorer) is not supported. Please use a modern browser like <a href="https://www.google.com/chrome/" target="_blank">Chrome</a> or <a href="https://www.mozilla.org/firefox/" target="_blank">Firefox</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
    <bt-footer />
  </div>
</template>
<script>
  export default {
    name: 'Browser',
    props: {
      browserName: {
        type: String,
        default: 'Internet Explorer'
      }
    }
  }
</script>
<style scoped>
</style>